import { useQuery } from "@tanstack/react-query";

import { getFarmLandUseChanges, getFarmLandUseChangesAdmin } from "services";

import { getEnvironment, shouldRetryQueryError } from "utils";

import { FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE } from "consts";

import { FarmLandUseChange } from "models";

export const useGetFarmLandUseChanges = (farmId: string, options?: { year?: number; range?: number }) => {
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getFarmLandUseChangesAdmin : getFarmLandUseChanges;

  return useQuery<FarmLandUseChange[]>({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE, farmId, options?.year],
    queryFn: async () => queryFn(farmId, options?.year, options?.range),
    retry: shouldRetryQueryError(),
    enabled: !!farmId,
    staleTime: 0,
    gcTime: 0,
  });
};
